import {TestPanel} from '@esgi/main/kits/test-results-panel';
import {styled} from '@esgi/ui/theme';

export const TestsPanelContainer = styled(TestPanel.Root, {
	paddingTop: 16,
	paddingBottom: 16,
	paddingInline: 20,
});
